// extracted by mini-css-extract-plugin
module.exports = {"submit":"styles_submit__UjZop","accepted":"styles_accepted__3DCAh","inputBox":"styles_inputBox__1h5Mj","inputRow":"styles_inputRow__eC3se","spin":"styles_spin__FZzIz"};